import React from 'react';
import { MessageCircle } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { Button } from './ui/button';
import { faqs, doctorInfo } from '../data/mock';

const FAQ = () => {
  const handleWhatsApp = () => {
    window.open(`https://wa.me/${doctorInfo.whatsapp}?text=${encodeURIComponent(doctorInfo.whatsappMessage)}`, '_blank');
  };

  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-[#3D2418]/10 via-[#7DAAAF]/15 to-[#7DAAAF]/20 relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#7DAAAF]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#3D2418]/5 rounded-full blur-3xl"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-16 animate-in">
          <div className="inline-block mb-4">
            <span className="text-[#7DAAAF] font-semibold text-sm tracking-wider uppercase">FAQs</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#3D2418] mb-6">
            Preguntas <span className="text-[#7DAAAF]">Frecuentes</span>
          </h2>
          <div className="w-32 h-1.5 bg-gradient-to-r from-[#7DAAAF] to-[#3D2418] rounded-full mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            Resuelve tus dudas sobre el servicio de atención médica a domicilio
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4 mb-12">
          {faqs.map((faq) => (
            <AccordionItem 
              key={faq.id} 
              value={`item-${faq.id}`}
              className="border-2 border-gray-200 rounded-2xl px-6 hover:border-[#7DAAAF] transition-all duration-300 bg-white shadow-md hover:shadow-lg"
            >
              <AccordionTrigger className="text-left hover:no-underline py-6">
                <span className="text-lg font-bold text-[#3D2418] pr-4">
                  {faq.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-gray-700 pb-6 leading-relaxed text-base">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Contact CTA */}
        <div className="text-center bg-gradient-to-br from-[#7DAAAF] to-[#6a959a] rounded-2xl sm:rounded-3xl p-6 sm:p-10 shadow-2xl transform hover:scale-[1.02] transition-transform">
          <MessageCircle className="w-12 h-12 sm:w-16 sm:h-16 text-white mx-auto mb-3 sm:mb-4" />
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3 sm:mb-4">
            ¿Tienes más preguntas?
          </h3>
          <p className="text-white/90 mb-4 sm:mb-6 text-base sm:text-lg px-2">
            No dudes en contactarme. Estaré encantado de ayudarte.
          </p>
          <Button 
            onClick={handleWhatsApp}
            data-testid="faq-whatsapp-btn"
            size="lg"
            className="bg-white text-[#7DAAAF] hover:bg-gray-100 font-bold text-base sm:text-lg px-6 sm:px-10 py-5 sm:py-6 shadow-xl hover:shadow-2xl transition-all w-full sm:w-auto"
          >
            <MessageCircle className="w-5 h-5 mr-2 flex-shrink-0" />
            <span className="whitespace-nowrap">Contactar por WhatsApp</span>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
